import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import toList from "../utils/ComponentUtil";
import CustomBreadcrumbs from "../utils/CustomBreadcrumbs";
import Header from "../utils/Header";
import AboutUsImg from '../../images/Group_743.png';
import AboutUs1 from '../../images/about/about-us-0.png';
import AboutUs2 from '../../images/about/about-us-1.png';
import AboutUs3 from '../../images/about/about-us-2.png';
import './AboutUs.scss';

function AboutHome() {
    const suitableFor = ["Retirees who want to stay active professionally and earn.",
    "Freelancers in search for better work opportunities.",
    "Anyone who is in need of an alternative working schedule.",
    "Housewives who can devote some hours only for jobs.",
    "Career oriented people who are looking for on site or remote jobs.",
    "Someone who needs an additional income through part time working opportunities by using his skills and work experience.",
    "People with health issues with restricted movement or those residing in remote areas, unable to relocate and hence need remote jobs.",
]

    const breadcrumbs = [toList([{ to: "/", child: "Home" }], Link)
        , <Typography>About Us</Typography>]

    return (
        <div className="about-us-container">
            <div className="about-us-home-wrp wrapper">
                <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                <div className="about-title-content">
                    <Header title='About Us' />
                    <div className="title-content">
                        jobfi.in have started in 2019 Commencement year 2019 and our core belief is to deliver an excellent experience to our subscribers. It is one of the best platforms to find all types of online jobs that you can do from the comfort of your home. We help to connect freelancers with firms that need skilled candidates. We aim to encourage people to use their skills and free time to earn a handsome amount. If you are a housewife, student, working professional, or teenager, then you have reached the best website to put your skill and talent to use.
                        <br />
                        <br />
                        The platform is not just for small jobs, you can even find bigger projects opt for ones with fixed price or hourly payment. You can talk to clients regarding the milestone, schedule, and cost before starting a project.
                    </div>
                    <img className='about-us-img' src={AboutUsImg} alt='about-us' />
                </div>
            </div>
            <div className="reason-container wrapper">
                <div className="reason-wrp">
                    <div className="title">Why use jobfi.in?</div>
                    <div className="reason">There are a vast number of job seekers in India where people look out for genuine job opportunities. Students, housewives and even the working personnel try to seek for additional income sources. In such a scenario, we aim to make your chances of finding the right jobs safe, quick and easy for you. It is like a one stop destination where you can find a lot of opportunities, right from basic typing jobs to ones that need lot of technical skills.</div>
                </div>
                <img className='about-us-img' src={AboutUs1} alt='about-us' />
            </div>
            <div className="reason-container reverse wrapper">
                <div className="reason-wrp">
                    <div className="title">Why use jobfi.in?</div>
                    <div className="reason">There are a vast number of job seekers in India where people look out for genuine job opportunities. Students, housewives and even the working personnel try to seek for additional income sources. In such a scenario, we aim to make your chances of finding the right jobs safe, quick and easy for you. It is like a one stop destination where you can find a lot of opportunities, right from basic typing jobs to ones that need lot of technical skills.</div>
                </div>
                <img className='about-us-img' src={AboutUs2} alt='about-us' />
            </div>
            <div className="reason-container wrapper">
                <div className="reason-wrp">
                    <div className="title">Why use jobfi.in?</div>
                    <div className="reason">There are a vast number of job seekers in India where people look out for genuine job opportunities. Students, housewives and even the working personnel try to seek for additional income sources. In such a scenario, we aim to make your chances of finding the right jobs safe, quick and easy for you. It is like a one stop destination where you can find a lot of opportunities, right from basic typing jobs to ones that need lot of technical skills.</div>
                </div>
                <img className='about-us-img' src={AboutUs3} alt='about-us' />
            </div>
            <div className="who-should-use-wrp">
                <div className="wrapper">
                <div className="title">Who should use jobfi.in?</div>
                <div className="content">This website is perfect for anyone looking out for flexible job opportunities like freelancing, work from home jobs or other remote jobs. There are various categories, right from entry level to executive level jobs, freelancers to full time jobs. Thus, every type of job seeker can find something useful for them.</div>
                </div>
            </div>
            <div className="suitable-for-wrp wrapper">
                <div className="title">In short, it is most suitable for:</div>
                <div className="suits-for-cards">
                    {toList(suitableFor, undefined, (item, i)=> <div key={i} className="suit-for-card">
                        <div className="point-wrp">
                            <div className="point"></div>
                            <div className="number">{(i < 10 ? '0' : '')+(i+1)}</div>
                        </div>
                        <div className="content">{item}</div>
                    </div>)}
                </div>
            </div>
        </div>
    );
}

export default AboutHome;